import { render, staticRenderFns } from "./AspectRatioSVG.vue?vue&type=template&id=1980299f"
import script from "./AspectRatioSVG.vue?vue&type=script&lang=ts"
export * from "./AspectRatioSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports